// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import {Routing} from 'nutshell-core/routing';

import type {AiFeaturePeriod} from 'nutshell-graphql-types';

import {readLocalStorage, writeLocalStorage} from '../../util/localStorage';

const VALID_PERIOD_VALUES: Array<AiFeaturePeriod> = ['ALL', 'MONTH', 'WEEK', 'YEAR'];
const AI_HOMEPAGE_PERIOD_STORAGE_KEY = 'ai-homepage-period';

export const handleSelectedUsageTabChange = (
    period: AiFeaturePeriod,
    history: RouterHistory,
    pathname: string
) => {
    writeLocalStorage(AI_HOMEPAGE_PERIOD_STORAGE_KEY, period);

    history.replace({
        pathname: pathname,
        search: `?period=${period.toLowerCase()}`,
    });
};

export const getSelectedUsageTab = (search: string): AiFeaturePeriod => {
    const params = Routing.deparam(search.replace(/^\?/, ''));
    const urlPeriod = params.period && params.period.toUpperCase();

    if (VALID_PERIOD_VALUES.includes(urlPeriod)) {
        return urlPeriod;
    }

    const storedPeriod = readLocalStorage(AI_HOMEPAGE_PERIOD_STORAGE_KEY);
    if (storedPeriod && VALID_PERIOD_VALUES.includes(storedPeriod as AiFeaturePeriod)) {
        return storedPeriod as AiFeaturePeriod;
    }

    return 'WEEK';
};
